<template>
  <div class="proDetails">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22" class="topTips">
          <label>商品基本信息</label>
          <el-button type="primary" @click="chooseGoods" v-if="$route.meta.add">选择商品</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>品牌</span>
          </label>
          {{$store.state.userInfo.brandId == 1 ? '婷美摩力21产后恢复' : ($store.state.userInfo.brandId == 2 ? '臻幼堂小儿推拿' : '槑博士婴幼儿草本浴')}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>类别</span>
          </label>
          {{infodetails.addType | filterAddType}}
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>商品名称</span>
          </label>
          {{infodetails.serviceName}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>建议套餐价</span>
          </label>
          {{infodetails.price ? '¥'+Number(infodetails.price).toFixed(2) :''}}
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>建议单次价</span>
          </label>
          {{infodetails.oneprice ? '¥'+Number(infodetails.oneprice).toFixed(2) :''}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>商品状态</span>
          </label>
          <span class="red" v-if="infodetails.forSale == 0">禁用</span>
          <span v-else>启用</span>
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10" class="topTips">
          <label>商品售卖信息</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <el-form-item label="数量" prop="serviceRevise.goodsnum">
            <span v-if="$route.meta.view">12</span>
            <el-input
              v-model="form.serviceRevise.goodsnum"
              placeholder="请输入数量"
              style="width:230px"   
              v-else           
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格" prop="serviceRevise.goodspecil">
            <span v-if="$route.meta.view">盒</span>
            <el-input
              v-model="form.serviceRevise.goodspecil"
              placeholder="请输入规格"
              style="width:230px"
              v-else
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>      
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <el-form-item label="售卖渠道" prop="serviceRevise.saleChannel" ref="mySalecode">
            <span v-if="$route.meta.view">门店</span>
            <el-checkbox-group v-model="form.serviceRevise.saleChannel" class="checkBoxcom" v-else>
              <el-checkbox label="1">门店</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="售价" prop="serviceRevise.price">
            <span v-if="$route.meta.view">￥122.00</span>
            <template v-else>
                <el-input
                placeholder="请输入售价"
                v-model="form.serviceRevise.price"
                style="width:200px"
                ></el-input>&nbsp;&nbsp;元
            </template>
          </el-form-item>
        </el-col>
      </el-row>      
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="serviceRevise.remarks">
              <span v-if="$route.meta.view">--</span>
            <el-input
              type="textarea"
              v-model="form.serviceRevise.remarks"
              style="width:300px;height:90px;"
              placeholder="100字以内"
              resize="none"
              v-else
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="$route.meta.view">
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22" class="topTips">
          <label>审核信息</label>
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
            <el-form-item label="审核结果">
                审核通过
            </el-form-item>
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
            <el-form-item label="审核意见">
                意见意见
            </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btnOptions">
          <template v-if="$route.meta.view">
              <el-button class="darkBtn" @click="closeTab">关闭</el-button>
          </template>
          <template v-else>
            <el-button class="darkBtn" @click="cancel">取消</el-button>
            <el-button class="redBtn" @click="submit" :disabled="clickFalg">保存并提交审核</el-button>
          </template>        
      </el-row>
    </el-form>

    <el-dialog title="选择商品" :visible.sync="dialogTableVisible" :center="true" width="1200px">
      <!-- 选择套盒 -->
      <goodsList
        @closeDialog='closeDialog'
        @mySelect="selectRowData"
      />
    </el-dialog>
  </div>
</template>
<script>
import goodsList from './goodsList'
import { ServiceInfos, insertService, updateService } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
    components: {
        goodsList
    },
  data() {
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (Number(value)) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 99999.99) {
          callback(new Error("金额最大99999.99"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      }else if(Number(value) === 0){
        callback();
      }else{
        callback(new Error("金额只能是数字，且保留两位小数"));
      }
    };
    return {
      form: {
        serviceRevise: {
          saleChannel: ['1'],
          price: "",
          goodsnum: "",
          goodspecil: "",
          remarks: ""
        }
      },
      serviceReviseFlag:true,//默认有数据修改
      dialogTableVisible:false,
      infodetails:'',
      rules: {
        serviceRevise: {
          saleChannel: [
            { required: true, message: "请选择售卖渠道", trigger: "change" }
          ],
          price: [
            {
              required: true,
              message: "请输入售价",
              trigger: "blur"
            },
            { type: "number", validator: isvalidateMoney }
          ],
          goodsnum: [
            { required: true, message: "请输入商品数量", trigger: "blur" },
            {
              min: 1,
              max: 20,
              message: "长度在 1 到 20 个字符",
              trigger: "blur"
            }
          ],
          goodspecil: [
            { required: true, message: "请输入规格", trigger: "blur" },
            {
              min: 1,
              max: 30,
              message: "长度在 1 到 30 个字符",
              trigger: "blur"
            }
          ],
          remarks: [
            {
              min: 0,
              max: 100,
              message: "长度在 100 个字符内",
              trigger: "blur"
            }
          ]
        }
      },
      clickFalg:false
    };
  },
  created() {
    this.detailInfo();
  },
  watch: {
    $route(to) {
      this.detailInfo();
    }
  },
  methods: {
    detailInfo() {
      ServiceInfos({
        serviceId: this.$route.params.id
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
          if (!this.form.serviceRevise) {
            this.serviceReviseFlag = false;
            this.form.serviceRevise = Object.assign(
              {},
              this.$options.data().form.serviceRevise
            );
          } else{
            if (!this.form.serviceRevise.saleChannel) {
              this.form.serviceRevise.saleChannel = [];
            }
            this.serviceReviseFlag = true;
          }
          setTimeout(()=>{this.$refs.mySalecode.clearValidate();})
        }
      });
    },
    chooseGoods(){
        // 选择商品
        this.dialogTableVisible = true;
    },
    closeDialog(val){
        this.dialogTableVisible = val;
    },
    selectRowData(info){
        // 选中
        this.dialogTableVisible = false;
        this.infodetails = info;
    },
    cancel(){
        // 取消
      this.$confirm('确定要取消'+(this.$route.meta.edit ? '编辑':'新增')+'该商品？取消后'+(this.$route.meta.edit ? '编辑':'新增')+'的信息不保存', "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "继续"+(this.$route.meta.edit ? '编辑':'新增'),
        cancelButtonText: "确定取消",
        type: "warning"
      })
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.closeTab()
          }
        });
    },
    closeTab() {
        this.$store.commit("delete_tabs", this.$route.path);
        this.$router.push("/businessManagementCenter/retailgoods");
    },
    onlySave(audStatus) {
      // 仅保存
      this.$refs.form.validate(valid => {
        if (valid) {
          this.clickFalg = true;
          // audStatus:1未提交审核 2未审核
          this.form.serviceRevise.serviceId = this.$route.params.id;
          this.form.serviceRevise.audStatus = audStatus;
          this.form.serviceRevise.serviceKind ='2';
          if (this.serviceReviseFlag) {
            // 有数据是编辑否则是新增
            updateService(this.form.serviceRevise).then(res => {
              if (res.code == 1) {
                // 关闭当前进入列表页
                this.$store.commit("delete_tabs", this.$route.path);
                this.$router.push("/businessManagementCenter/retailgoods");
              }
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.msg
              });
              setTimeout(()=>{
                this.clickFalg = false;
              })
            });
          } else {
            insertService(this.form.serviceRevise).then(res => {
              if (res.code == 1) {
                // 关闭当前进入列表页
                this.$store.commit("delete_tabs", this.$route.path);
                this.$router.push("/businessManagementCenter/retailgoods");
              }
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.msg
              });
              setTimeout(()=>{
                this.clickFalg = false;
              })
            });
          }
        } else {
          this.clickFalg = false;
          return false;
        }
      });
    },
    submit() {
      // 保存并提交审核
      this.$refs.form.validate(valid => {
        if (valid) {
          this.clickFalg = true;
          this.onlySave("2");
        } else {
          this.clickFalg = false;
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.proDetails {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  position: relative;
  .topTips {
    font-size: 17px;
    font-weight: bold;
    color: #444;
    margin: 20px 0;
  }
  .myTxt {
    width: 100%;
    padding-left: 150px;
    margin-top: -24px;
  }
  .seize {
    height: 20px;
  }
  .el-row {
    margin-bottom: 12px;
    .el-form-item {
      margin-bottom: 8px;
    }
  }
  label:not(.el-checkbox) {
    width: 140px;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .btnOptions {
    text-align: center;
    margin-top: 20px;
    .onSale {
      background: #2ecfa7;
      color: #fff;
    }
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
}
</style>
<style lang="less">
.proDetails{
    .el-dialog__title {
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/addGoods.vue